/**
 * SessionDataItem Component
 * Displays a single session data item with status/risk indicators
 */

import React from 'react';
import { Box, Typography } from '@saviynt/design-system';

import { RISK_INDICATORS, STATUS_INDICATORS } from '../../constants';
import { type SessionData } from '../../types';

interface SessionDataItemProps {
  item: SessionData;
  className?: string;
}

/**
 * SessionDataItem Component
 * Displays a single session data item with status/risk indicators
 * @param item - The session data to display
 * @param className - Optional CSS class name
 * @returns JSX element
 */
function SessionDataItem({ item, className = '' }: SessionDataItemProps) {
  const renderValue = () => {
    if (item.type === 'status' && item.status) {
      return (
        <Box className='Sod-InsightsPanel-sessions-detail-status'>
          <Box
            className={`Sod-InsightsPanel-sessions-detail-status-indicator ${item.status}`}
            style={{ backgroundColor: STATUS_INDICATORS[item.status] }}
          />
          <Typography
            kind='body2'
            className='Sod-InsightsPanel-sessions-detail-status-text'>
            {item.value}
          </Typography>
        </Box>
      );
    }

    if (item.type === 'risk' && item.risk) {
      return (
        <Box className='Sod-InsightsPanel-sessions-detail-risk'>
          <Box
            className={`Sod-InsightsPanel-sessions-detail-risk-indicator ${item.risk}`}
            style={{ backgroundColor: RISK_INDICATORS[item.risk] }}
          />
          <Typography
            kind='body2'
            className='Sod-InsightsPanel-sessions-detail-risk-text'>
            {item.value}
          </Typography>
        </Box>
      );
    }

    return (
      <Typography
        kind='body2'
        className='Sod-InsightsPanel-sessions-detail-value'>
        {item.value}
      </Typography>
    );
  };

  return (
    <Box
      className={`Sod-InsightsPanel-sessions-detail-item ${className || ''}`}>
      <Box className='Sod-InsightsPanel-sessions-detail-item-label'>
        <Typography
          kind='body3'
          className='Sod-InsightsPanel-sessions-detail-item-label-text'>
          {item.label}
        </Typography>
      </Box>
      <Box className='Sod-InsightsPanel-sessions-detail-item-metadata'>
        {renderValue()}
      </Box>
    </Box>
  );
}

SessionDataItem.defaultProps = {
  className: '',
};

export default SessionDataItem;
